import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`

const couponCodeValidation = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/coupon/code-validation`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const readCouponById = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/coupon/one`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const readCouponList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/coupon/list`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const createCoupon = async (coupon, userId) => {
  const res = await axios.post(`${baseUrl}/coupon/create`, coupon, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const editCoupon = async (coupon, userId) => {
  const res = await axios.post(`${baseUrl}/coupon/edit`, coupon, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const userCouponChangeStatus = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/user-coupon/change/available`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

const promotionApi = {
  couponCodeValidation,
  readCouponById,
  readCouponList,
  createCoupon,
  editCoupon,
  userCouponChangeStatus,
}

export default promotionApi
